<img

    [src]="hiddenImageSrc"
    [width]="width"
    [height]="height"
    [alt]="tilte"
    loading="lazy"
    decoding="async"
    class="svg-canvas-seo-img"
  />
<canvas #canvas [width]="width" [height]="height" [ariaLabel]="'icons'">
</canvas>

<p class="mt-2 text-sm text-center">{{gettitle()}}</p>
